import Icon from 'veui/components/Icon'
import { IconDoubleCircle } from 'dls-icons-vue'

Icon.register('double-circle', IconDoubleCircle)
